<script>
export default {
  data() {
    return {
      collection: [],
    };
  },

  computed: {
    innovationLibraryPath() {
      if (this.collection.length == 0) {
        return `/innovation-library/innovations`;
      } else {
        const paramsString = this.collection.map((id) => `objectives%5B%5D=${id}`).join('&');
        return `/innovation-library/innovations?${paramsString}`;
      }
    },
  },

  methods: {
    changeCollection(id) {
      if (this.collection.includes(id)) {
        let index = this.collection.indexOf(id);
        this.collection.splice(index, 1);
      } else {
        this.collection.push(id);
      }
    },
  },

  watch: {
    collection(newVal) {
      let feedbackmodal = document.getElementById('feedback-modal');
      if (newVal.length > 0) {
        feedbackmodal.classList.add('bottom-displacement');
      } else {
        feedbackmodal.classList.remove('bottom-displacement');
      }
    },
  },
};
</script>
